// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.externaltour.RentalManagerUserPropertyExternalTourWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyExternalTourAddForListingRequestWebDto,
  UserPropertyExternalTourAddForListingResponseWebDto,
  UserPropertyExternalTourAddForModelRequestWebDto,
  UserPropertyExternalTourAddForModelResponseWebDto,
  UserPropertyExternalTourRemoveFromListingRequestWebDto,
  UserPropertyExternalTourRemoveFromModelRequestWebDto,
} from '../..';

interface AddExternalTourForListingParams {
  listingAlias: ListingAlias;
}
interface AddExternalTourForModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
}
interface RemoveExternalTourFromListingParams {
  listingAlias: ListingAlias;
}
interface RemoveExternalTourFromModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Path =
  '/api/web/v1/users/properties/externalTour/addExternalTourForListing';

/**
 * Associate an external tour to a building/listing
 */
export const RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing = (
  getParams: AddExternalTourForListingParams,
  postData: UserPropertyExternalTourAddForListingRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    AddExternalTourForListingParams,
    UserPropertyExternalTourAddForListingRequestWebDto,
    UserPropertyExternalTourAddForListingResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Path =
  '/api/web/v1/users/properties/externalTour/addExternalTourForModel';

/**
 * Associate an external tour to a unit/floor plan
 */
export const RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel = (
  getParams: AddExternalTourForModelParams,
  postData: UserPropertyExternalTourAddForModelRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    AddExternalTourForModelParams,
    UserPropertyExternalTourAddForModelRequestWebDto,
    UserPropertyExternalTourAddForModelResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Path =
  '/api/web/v1/users/properties/externalTour/removeExternalTourFromListing';

/**
 * Remove an external tour from a building/listing
 */
export const RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing = (
  getParams: RemoveExternalTourFromListingParams,
  postData: UserPropertyExternalTourRemoveFromListingRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    RemoveExternalTourFromListingParams,
    UserPropertyExternalTourRemoveFromListingRequestWebDto,
    void
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Path =
  '/api/web/v1/users/properties/externalTour/removeExternalTourFromModel';

/**
 * Remove an external tour from a unit/floor plan
 */
export const RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel = (
  getParams: RemoveExternalTourFromModelParams,
  postData: UserPropertyExternalTourRemoveFromModelRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    RemoveExternalTourFromModelParams,
    UserPropertyExternalTourRemoveFromModelRequestWebDto,
    void
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
